import script from "./RoomCurtainItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomCurtainItem.vue?vue&type=script&setup=true&lang=js"

import "./RoomCurtainItem.vue?vue&type=style&index=0&id=bc5f6f62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc5f6f62"]])

export default __exports__